import React from 'react';
import CaseStudyTemplate, {
  CaseStudySection,
  GraphicPlaceholder,
  StoryParagraph,
} from './CaseStudyTemplate';

const MassCaseStudy = () => (
  <CaseStudyTemplate
    title="Designing a field-ready inventory workflow for the Massachusetts National Guard"
    intro="For a senior capstone partnership, we redesigned a manual inventory process into a mobile-first system that helps EOD technicians track critical equipment with higher confidence and less friction."
    details={[
      { label: 'Role', value: 'Product Designer' },
      { label: 'Timeline', value: '4 months' },
      { label: 'Client', value: 'Massachusetts Army National Guard' },
      { label: 'Context', value: 'Senior capstone project' },
    ]}
    sectionNav={[
      { id: 'overview', label: 'Overview' },
      { id: 'architecture', label: 'Architecture' },
      { id: 'features', label: 'Features' },
      { id: 'notes', label: 'Notes' },
    ]}
    backTarget="selected-work"
  >
    <CaseStudySection id="overview" title="Overview">
      <StoryParagraph>
        Equipment tracking was spreadsheet-heavy, fragmented, and difficult to trust in fast-moving field conditions. The team needed faster verification and fewer handoff errors.
      </StoryParagraph>
    </CaseStudySection>
    <CaseStudySection id="architecture" title="Architecture">
      <StoryParagraph>
        We structured the product around three anchors: inventory readiness, item-level traceability, and streamlined update workflows that work on mobile in real conditions.
      </StoryParagraph>
      <GraphicPlaceholder
        title="Graphic placeholder: operational workflow map"
        note="Show legacy manual process against mobile workflow with reduced steps and clearer ownership."
      />
    </CaseStudySection>
    <CaseStudySection id="features" title="Features">
      <StoryParagraph>
        The concept prioritized clear scan and logging behaviors, equipment status visibility, and task-oriented screens that minimize cognitive load under operational pressure.
      </StoryParagraph>
    </CaseStudySection>
    <CaseStudySection id="notes" title="Notes">
      <StoryParagraph>
        Designing for mission-critical contexts changed how I evaluate interface decisions. Clarity is not aesthetic preference here, it is risk reduction.
      </StoryParagraph>
    </CaseStudySection>
  </CaseStudyTemplate>
);

export default MassCaseStudy;
